import styled from "styled-components"

export * from "./alertMessage"
export * from "./balloonMessage"
export * from "./button"
export * from "./buttonGroup"
export * from "./ckeditor"
export * from "./collapse"
export * from "./colorPicker"
export * from "./confirm"
export * from "./dateFormatter"
export * from "./datepicker"
export * from "./deadline"
export * from "./default"
export * from "./deleteButton"
export * from "./deleteConfirm"
export * from "./empty"
export * from "./feedback"
export * from "./formLayout"
export * from "./help"
export * from "./icons"
export * from "./increaseInput"
export * from "./list"
export * from "./loader"
export * from "./logo"
export * from "./lostConnection"
export * from "./nestedHistoryList"
export * from "./notAssigned"
export * from "./pageLayout"
export * from "./popupMenu"
export * from "./radioButton"
export * from "./router"
export * from "./searchBar"
export * from "./selectDropdown"
export * from "./sliderSwitcher"
export * from "./spinner"
export * from "./statusSwitcher"
export * from "./table"
export * from "./table/styled"
export * from "./table/moveBottom"
export * from "./table/permissions"
export * from "./table/permissions/styled"
export * from "./tablePopover"
export * from "./tagEditor"
export * from "./userDropdown"
export * from "./userIcon"

// includes upper scope
export * from "./accountDropdown"
export * from "./fileLoader"
export * from "./recentVersions"
export * from "./ckeditorAttachments/view"
export * from "./ckeditorAttachments/edit"
export * from "./comments"
export * from "./langSwitcher"

export const Expired = styled.div`
    color: ${(props) => props.theme.defaultErrorColor};
`
